/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Bridge_Default_Override_ActiveInputs */



/**
* | output |
* | --- |
* | "Set explicitly by an administrator, overriding the default." |
*
* @param {Api_Bridge_Default_Override_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_bridge_default_override_active = /** @type {((inputs?: Api_Bridge_Default_Override_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Bridge_Default_Override_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Von einer Administratorin ausdrücklich gesetzt und überschreibt die Voreinstellung.")
	return /** @type {LocalizedString} */ ("Set explicitly by an administrator, overriding the default.")
});